<script setup lang="ts">
import AccordionComponent from "@/components/accordion/AccordionComponent.vue";
import { defineProps, inject, ref, defineModel, watch } from "vue";
import { DestinyMatrix, DestinyMatrixKeysEnum } from "@/types/destinyMatrix";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  matrix: DestinyMatrix | undefined;
  hasPremiumAccess: boolean;
}>();
const isOpen = defineModel<boolean>({ default: false });
const getDescription =
  inject<(key: DestinyMatrixKeysEnum) => Promise<never>>("getDescription");

const { t } = useI18n();

watch(
  () => props.matrix,
  () => (description.value = undefined)
);

const description = ref();

async function getData() {
  if (!props.hasPremiumAccess) {
    isOpen.value = false;
  }
  if (!description.value && props.matrix && getDescription) {
    description.value = await getDescription(
      DestinyMatrixKeysEnum.PREVIOUS_LIVES_TASKS
    );
  }
}
</script>

<template>
  <AccordionComponent
    type="white"
    @opened="getData"
    v-model="isOpen"
    :isBlocked="!hasPremiumAccess"
  >
    <template #title>
      {{
        t("calculators.destiny-matrix.accordions.previous-lives-tasks.title")
      }}
    </template>
    <template #faq-content>
      <div v-if="description" class="flex flex-col gap-2">
        <div class="whitespace-pre-line">
          {{
            t("calculators.destiny-matrix.accordions.previous-lives-tasks.desc")
          }}
        </div>
        <p class="text-xl font-bold pt-4">
          {{
            t(
              "calculators.destiny-matrix.accordions.previous-lives-tasks.main-soul-task-title",
              { value: matrix.r1.b }
            )
          }}
        </p>
        <div class="whitespace-pre-line">
          {{ description[matrix.r1.b] }}
        </div>
        <p v-if="matrix.r1.b !== matrix.r3.b" class="text-xl font-bold pt-4">
          {{
            t(
              "calculators.destiny-matrix.accordions.previous-lives-tasks.communicate-soul-exp-title",
              { value: matrix.r3.b }
            )
          }}
        </p>
        <div class="whitespace-pre-line">
          {{ description[matrix.r3.b] }}
        </div>
        <p
          v-if="matrix.r1.b !== matrix.r2.b && matrix.r3.b !== matrix.r2.b"
          class="text-xl font-bold pt-4"
        >
          {{
            t(
              "calculators.destiny-matrix.accordions.previous-lives-tasks.prev-life-lesson-title",
              { value: matrix.r2.b }
            )
          }}
        </p>
        <div class="whitespace-pre-line">
          {{ description[matrix.r2.b] }}
        </div>
      </div>
    </template>
    <template #collapse-text-btn>
      {{ t("calculators.destiny-matrix.accordions.collapse") }}
    </template>
  </AccordionComponent>
</template>
